import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    'Authorization': `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getPayrolls = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Payroll/get`, {
      payroll_Id: filter.payroll_Id || null,
      payroll_Date: filter.payroll_Date || null
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("[PayrollAPI] Failed to fetch payrolls:", error);
    throw error;
  }
};

export const checkPayrollDateUpdate = async (payrollId = null) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Payroll/check-date-update`, {
      Payroll_Id: payrollId
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("[PayrollAPI] Failed to check date update:", error);
    throw error;
  }
};

export const createFirstPayroll = async (payrollDate, createdBy) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Payroll/create-first`, {
      Payroll_Date: payrollDate,
      Created_By: createdBy
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("[PayrollAPI] Failed to create first payroll:", error);
    throw error;
  }
};

export const updatePayrollDate = async (payrollId, newPayrollDate, updatedBy) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Payroll/update-date`, {
      Payroll_Id: payrollId,
      New_Payroll_Date: newPayrollDate,
      Updated_By: updatedBy
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("[PayrollAPI] Failed to update payroll date:", error);
    throw error;
  }
};

export const skipPayroll = async (payrollId, skippedBy, skippedDate) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Payroll/skip`, {
      Payroll_Id: payrollId,
      Skipped_By: skippedBy,
      Skipped_Date: skippedDate
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("[PayrollAPI] Failed to skip payroll:", error);
    throw error;
  }
};

// API to export payroll history report to Excel
export const exportPayrollHistoryToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Payroll/export-history-excel`, {
      payroll_Id: filter.payroll_Id || null
    }, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `PayrollHistoryReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting payroll history report:", error);
    throw error;
  }
}; 